import { fetchAPI } from "@/api/api"
import { queryEventLabelResponseSchema } from "@/schemas/websiteInfo"
import { z } from "zod/v4"
import { stringParam, booleanParam } from "@/schemas/requestParams"

const URL = "/exchange/member/playerService/queryEventLabel"

// queryEventLabel (PlayerController.java:4236-4242)
const queryEventLabelRequestSchema = z.strictObject({
  isMobile: booleanParam.optional(),
  lang: stringParam(2).optional()
})

export type Payload = {
  isMobile: boolean
}

const fetch = {
  url: URL,
  handler: async ({ payload }: { payload: Payload }) => {
    try {
      const { isMobile } = payload

      const res = await fetchAPI({
        url: URL,
        method: "post",
        withCredentials: true,
        pageName: "",
        data: {
          isMobile: isMobile ? 1 : 0
        },
        hasStatus: true,
        requestSchema: queryEventLabelRequestSchema,
        schema: queryEventLabelResponseSchema
      })

      return Promise.resolve(res.eventLabel)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default fetch
